import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { CaptainDAO } from '../../../../../../core/services/dao/captainDAO';
import { UserDAO } from '../../../../../../core/services/dao/userDAO';

@Component({
  selector: 'app-edit-description',
  templateUrl: './edit-description.component.html',
  styleUrls: ['./edit-description.component.scss'],
})
export class EditDescriptionComponent implements OnInit, OnDestroy {
  model: Captain;

  private oldLicense;
  private oldLicensed;

  constructor(
    private captainDAO: CaptainDAO,
    private userDAO: UserDAO,
    private router: Router,
  ) {}

  ngOnInit() {
    const user = this.userDAO.getCurrentUser();
    this.model = user.captain;
    this.oldLicensed = this.model.uscgLicensed;
    this.oldLicense = this.model.uscgLicenseNumber;
  }

  ngOnDestroy(): void {}

  save(captain: any) {
    if (
      captain.uscgLicensed === true &&
      (captain.uscgLicensed !== this.oldLicensed ||
        captain.uscgLicenseNumber !== this.oldLicense)
    ) {
      captain.status = 'inactive';
    }
    this.captainDAO.updateUserCaptain(captain).subscribe((result) => {
      this.router.navigate(['manage']);
    });
  }
}
